/**
 * A file to store 'lists' that are used to show things in the experiences page
 */

import config from 'constants/config'
import Places from 'constants/places'
import { EmptyArray } from 'lib/array/arrayUtils'

export interface ExpListDefinition {
  // The category code to filter the list on
  code?: number;
  // Will appear as the 'name' of the carousel
  title: string;
  // List of places to choose between
  places?: Array<App.Place>;
  // Adds current location to list of places
  // also sets it to default if default not already set
  currentLocation?: boolean;
  // How to sort the carousel
  sortBy?: Experiences.SortTypes;
}

export const categoryCarousels: Array<ExpListDefinition> = [
  {
    code: 9,
    title: 'Top activities for you',
  },
  {
    code: 1,
    title: 'Discover dining experiences',
  },
  {
    code: 18,
    title: 'See the sights',
  },
  {
    code: 48,
    title: 'Explore your destination',
  },
  {
    code: 27,
    title: 'Live events',
  },
  {
    code: 31,
    title: 'Indulge yourself',
  },
]

export interface PlaceImage {
  place: App.Place;
  imageId: string ;
}

const locationToImage = {
  Bali: { place: Places.Bali, imageId: 'ln4023ramv7vzfx310m' },
  Fiji: { place: Places.Fiji, imageId: '4a0mimshih2pj7aou3bi' },
  Whitsundays: { place: Places.Whitsundays, imageId: '6dngkpb8g5gol1ywhxr' },
  Thailand: { place: Places.Thailand, imageId: 'licfk8swbf937eo93ikw' },
  NewZealand: { place: Places.NewZealand, imageId: '837iqzyzudayjk6q1poj' },
  Maldives: { place: Places.Maldives, imageId: 'linrnpyof35g662y6zca' },
  Canada: { place: Places.Canada, imageId: 'b2cj2rj065pzf13c4b9' },
  Mexico: { place: Places.Mexico, imageId: '1umrk1sb3781quyi2yk5' },
  UnitedArabEmirates: { place: Places.UnitedArabEmirates, imageId: 'ere5bptnqvtae9l8hqlb' },
  Italy: { place: Places.Italy, imageId: 'ssja6nfqwfu4cd4ra0d' },
  Jamaica: { place: Places.Jamaica, imageId: '55rkl9mvjdmwvdgkvzb' },
  SouthAfrica: { place: Places.SouthAfrica, imageId: 'f0357jbjil2vktc6v98l6' },
  UnitedKingdom: { place: Places.UnitedKingdom, imageId: 'zhq59roxpimcicpawdk' },
  UnitedStates: { place: Places.UnitedStates, imageId: 'ytdpjzwweidaag3psz0n' },
  Singapore: { place: Places.Singapore, imageId: 'k9xrtouhguszlvtwtu46h' },
  Victoria: { place: Places.Victoria, imageId: '0h1arx6nnm0gslh04pba' },
  Vietnam: { place: Places.Vietnam, imageId: 'erihhrybfctjcdkilxo1' },
  // Perth: { place: Places.Perth, imageId: '' },
  // Cairns: { place: Places.Cairns, imageId: '' },
  // Sydney: { place: Places.Sydney, imageId: '' },
}

const locationsByRegion: Record<string, Array<PlaceImage>> = {
  au: [
    locationToImage.Bali,
    locationToImage.Fiji,
    locationToImage.Whitsundays,
    locationToImage.Thailand,
    locationToImage.NewZealand,
    locationToImage.Maldives,
  ],
  us: [
    locationToImage.Canada,
    locationToImage.Mexico,
    locationToImage.UnitedArabEmirates,
    locationToImage.Italy,
    locationToImage.Jamaica,
    locationToImage.SouthAfrica,
  ],
  in: [
    locationToImage.UnitedArabEmirates,
    locationToImage.Bali,
    locationToImage.UnitedKingdom,
    locationToImage.Thailand,
    locationToImage.Victoria,
    locationToImage.Maldives,
  ],
  nz: [
    locationToImage.Fiji,
    locationToImage.Bali,
    locationToImage.UnitedStates,
    locationToImage.Singapore,
    locationToImage.Victoria,
    locationToImage.Maldives,
  ],
  uk: [
    locationToImage.UnitedKingdom,
    locationToImage.Italy,
    locationToImage.Thailand,
    locationToImage.Canada,
    locationToImage.Fiji,
    locationToImage.SouthAfrica,
  ],
  sg: [
    locationToImage.Singapore,
    locationToImage.Bali,
    locationToImage.Victoria,
    locationToImage.Vietnam,
    locationToImage.Thailand,
    locationToImage.UnitedKingdom,
  ],
}

// Temporarily disabled by order of the almighty Shay
// const whitelabelLocations = [
//   locationToImage.Victoria,
//   locationToImage.Whitsundays,
//   locationToImage.NewZealand,
//   locationToImage.Bali,
//   locationToImage.Thailand,
// ]

export function getExperiencesPageLocations(region: string) {
  if (config.BRAND === 'luxuryescapes') {
    return locationsByRegion[region] ?? EmptyArray
  }
  return EmptyArray
}

const whiteLabelEditorsLocations = [Places.Sydney, Places.Melbourne, Places.Perth, Places.GoldCoast]
export function getEditorPickLocations(): Array<App.Place> {
  if (config.BRAND === 'luxuryescapes') {
    return EmptyArray
  }
  return whiteLabelEditorsLocations
}
